module.exports = __webpack_public_path__ + "img/boleto-barcode.60e81b37.svg";